/**
 * Configuration centrale de l'application
 *
 * Pour la production, modifier les URLs ci-dessous ou utiliser
 * les variables d'environnement REACT_APP_*
 */

const config = {
    // URL de base du backend (sans /api)
    // Dev: 'http://localhost/signature-builder-backend'
    // Prod: 'https://api.signly.fr'
    backendUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost/signature-builder-backend',

    // URL de l'API (avec /api)
    get apiUrl() {
        return `${this.backendUrl}/api`;
    },

    // Helper pour construire une URL d'upload
    getUploadUrl(path) {
        return `${this.backendUrl}${path}`;
    },

    // Helper pour construire une URL de thumbnail
    getThumbnailUrl(uid) {
        return `${this.apiUrl}/uploads/thumbnails/${uid}.png?t=${Date.now()}`;
    },

    // Helper pour construire une URL d'icône
    getIconUrl(style, name, size, color) {
        const colorHex = color.replace('#', '');
        return `${this.apiUrl}/icons/${style}_${name}_${size}_${size}_${colorHex}.png`;
    }
};

export default config;
